import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { useLocation } from "react-router-dom";
import { SiderApp } from "./Sider";
import { HeaderApp } from "./Header";
import { ROUTE_TITLES } from "./menu-items";
import CommandPalette from "../CommandPalette";
import Breadcrumbs from "../Breadcrumbs";
import styles from "./styles.module.scss";

const { Content } = Layout;

interface LayoutProps {
  children: React.ReactNode;
}

const LayoutApp: React.FC<LayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const basePath = `/${location.pathname.split("/")[1]}`;
    const sectionTitle = ROUTE_TITLES[basePath];
    document.title = sectionTitle
      ? `Emmi Admin — ${sectionTitle}`
      : "Emmi Admin";
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SiderApp collapsed={collapsed} />
      <Layout>
        <HeaderApp collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content className={styles.content}>
          <Breadcrumbs />
          {children}
        </Content>
      </Layout>
      <CommandPalette />
    </Layout>
  );
};

export default LayoutApp;
